import { createTheme } from "@mui/material/styles";
export const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#186FE7",
        },
    },

    typography: {
        fontFamily: "Inter",

        body2: {
            fontFamily: "Arimo",
        },
    },
});
